import { render, staticRenderFns } from "./OrbitFundProjectModal.vue?vue&type=template&id=0b52c03a"
import script from "./OrbitFundProjectModal.vue?vue&type=script&lang=ts"
export * from "./OrbitFundProjectModal.vue?vue&type=script&lang=ts"
import style0 from "./OrbitFundProjectModal.vue?vue&type=style&index=0&id=0b52c03a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports